export const versionRegex = /^(\d+\.)(\d+\.)(\*|\d+)$/

export const operators = {
    gt: {
        label: 'greater than >',
        symbol: '>',
        id: 'gt'
    },
    gte: {
        label: 'greater than or equal ≥',
        symbol: "≥",
        id: 'gte'
    },
    lt: {
        label: 'less than <',
        symbol: '<',
        id: 'lt'
    },
    lte: {
        label: 'less than or equal ≤',
        symbol: '≤',
        id: 'lte'
    },
    eq: {
        label: "equal =",
        symbol: "=",
        id: 'eq'
    },
    between: {
        label: "between ] [",
        symbol: "] {x} - {y} [",
        id: 'between'
    }
}

export const generateId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substr(2)
}